var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIconDesktopRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6035 38.1667L39.9368 61.5L33.9993 67.3333L0.666016 34L33.9993 0.666656L39.9368 6.49999L16.6035 29.8333H67.3327V38.1667H16.6035Z",
    fill: "#FEFEFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconDesktopRules);
export default __webpack_public_path__ + "static/media/back-icon-desktop-rules.eae4787fb7346e038c16f3a987d9d42d.svg";
export { ForwardRef as ReactComponent };